import { engineList, engineValueList } from "../constants";

export const isMobile = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );

export const cutFilename = (filename) => {
    const len = isMobile ? 8 : 12
    if (filename.length < len) {
        return filename
    }
    const index = filename.lastIndexOf('.')
    const suffix = filename.substring(index)
    const name = filename.substring(0, index)
    return `${name.substring(0, len-5)}..${suffix}`
}

export const getFileSize = (fileSize) => {
    const kb = fileSize / 1024;
    const mb = kb / 1024;
    if (mb > 0.1) {
        return mb.toFixed(2) + ' MB'
    }
    return kb.toFixed(2) + ' KB'
}

export const getFileExt = (name) => {
    return name.substr(name.lastIndexOf(".") + 1).toLowerCase();
}

// 矫正engine的值
export const fixEngineValues = (values) => {
    return values.filter(e => engineValueList.includes(e))
}

export const getEngineObj = (val) => {
    return engineList.find((e) => e.value === val)
}

export const getEngineName = (val) => {
    return getEngineObj(val)?.name;
}

export const getEngineIcon = (val) => {
    return getEngineObj(val)?.icon;
}

export const getEngineVersion = (val) => {
    return getEngineObj(val)?.version;
}